import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import {
  ALL_PROJECTS_FILTER,
  type ProjectFilter,
} from "../../utils/filterSimulations"

export interface HumanReviewProjectOption {
  ulid: string
  name: string
}

interface HumanReviewProjectFilterProps {
  value: ProjectFilter
  onValueChange: (value: ProjectFilter) => void
  projects: HumanReviewProjectOption[]
}

/**
 * Toolbar dropdown that scopes annotations to one linked Human Review project.
 * It is the one header control allowed to shrink, so a narrow drawer ellipsizes
 * the project name instead of pushing Close out of view. Renders nothing when
 * the metric has no linked projects.
 */
export function HumanReviewProjectFilter({
  value,
  onValueChange,
  projects,
}: HumanReviewProjectFilterProps) {
  if (projects.length === 0) {
    return null
  }

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        className="w-auto min-w-20 max-w-[220px]"
        aria-label="Human review project filter"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end" className="max-w-[320px]">
        <SelectItem value={ALL_PROJECTS_FILTER}>All Projects</SelectItem>
        {projects.map((project) => (
          <SelectItem
            key={project.ulid}
            value={project.ulid}
            className="wrap-anywhere"
          >
            {project.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
